import React from 'react';

const IconFigmaSelected = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={114}
    height={16.5}
    viewBox="0 0 76 11"
    fill="none"
    {...props}
  >
    <path
      d="M75.4874 0.300781H73.4775C73.3394 0.300781 73.2072 0.368737 73.1353 0.480184L70.6739 4.22589L70.5042 4.46509C70.4036 4.61459 70.3317 4.57925 70.3317 4.57925C70.2684 4.57925 70.1678 4.46509 70.1678 4.46509L69.9895 4.2286L67.5281 0.482902C67.4534 0.371455 67.324 0.303499 67.1859 0.303499H65.176C64.9546 0.303499 64.7734 0.474747 64.7734 0.68405V10.4343C64.7734 10.6436 64.9546 10.8148 65.176 10.8148H66.769C66.9904 10.8148 67.1716 10.6436 67.1716 10.4343V5.55781V5.26696V4.64993V4.38354C67.1716 4.38354 67.1687 4.23132 67.2952 4.23132C67.3556 4.23132 67.3671 4.2123 67.4447 4.34005L67.9681 5.13921L70.0327 8.10206C70.0327 8.10206 70.3317 8.40378 70.5847 8.08032L72.6292 5.14736L73.1468 4.35908C73.2273 4.23132 73.2129 4.23132 73.3337 4.23132C73.4861 4.23132 73.4573 4.38354 73.4573 4.38354V4.64993V5.19901C73.4573 5.20716 73.4602 5.2126 73.4602 5.22075V10.4316C73.4602 10.6409 73.6414 10.8121 73.8628 10.8121H75.4874C75.7088 10.8121 75.89 10.6409 75.89 10.4316V0.68405C75.89 0.472029 75.7117 0.300781 75.4874 0.300781Z"
      fill="#FF560F"
    />
    <path
      d="M0 5.59329V5.56339C0 2.57335 2.38376 0.126953 5.7998 0.126953C7.63722 0.126953 8.83054 0.63526 9.79094 1.40723C10.0152 1.58664 10.0354 1.9101 9.8427 2.11941L8.97144 3.06806C8.78166 3.27465 8.4596 3.29639 8.23244 3.12786C7.49633 2.5815 6.7257 2.25803 5.78255 2.25803C3.90775 2.25803 2.55628 3.72859 2.55628 5.53077V5.74279C2.55628 7.44167 3.99114 8.86874 5.7883 8.86602C6.87235 8.8633 7.59984 8.51265 8.33309 7.93911C8.54875 7.77058 8.85929 7.78417 9.05482 7.96901L9.88583 8.76273C10.0957 8.96388 10.0929 9.29006 9.87721 9.48306C8.82479 10.4263 7.60847 10.9971 5.69916 10.9971C2.42976 10.9998 0 8.61322 0 5.59329Z"
      fill="#FF560F"
    />
    <path
      d="M12.1875 6.84248V6.81258C12.1875 4.49938 14.1572 2.62109 16.8112 2.62109C19.448 2.62109 21.4034 4.46948 21.4034 6.77997V6.80987C21.4034 9.12307 19.4337 11.0014 16.7796 11.0014C14.1399 11.0014 12.1875 9.15569 12.1875 6.84248ZM19.0196 6.84248V6.81258C19.0196 5.62744 18.1138 4.58908 16.7796 4.58908C15.3965 4.58908 14.5713 5.59482 14.5713 6.78268V6.81258C14.5713 8.00045 15.477 9.03609 16.8112 9.03609C18.1915 9.03337 19.0196 8.02763 19.0196 6.84248Z"
      fill="#FF560F"
    />
    <path
      d="M24.1303 3.04688H24.162C24.8636 3.04688 25.4329 3.58508 25.4329 4.24833C25.4329 4.91157 24.8636 5.44978 24.162 5.44978H24.1303C23.4287 5.44978 22.8594 4.91157 22.8594 4.24833C22.8594 3.58508 23.4287 3.04688 24.1303 3.04688Z"
      fill="#FF560F"
    />
    <path
      d="M24.1303 8.10547H24.162C24.8636 8.10547 25.4329 8.64367 25.4329 9.30692C25.4329 9.97016 24.8636 10.5084 24.162 10.5084H24.1303C23.4287 10.5084 22.8594 9.97016 22.8594 9.30692C22.8594 8.64367 23.4287 8.10547 24.1303 8.10547Z"
      fill="#FF560F"
    />
    <path
      d="M31.5427 2.43458H28.9979C28.765 2.43458 28.5781 2.2579 28.5781 2.03772V0.697641C28.5781 0.477465 28.765 0.300781 28.9979 0.300781H37.3742C37.6071 0.300781 37.794 0.477465 37.794 0.697641V2.03772C37.794 2.2579 37.6071 2.43458 37.3742 2.43458H34.8294C34.5965 2.43458 34.4096 2.61127 34.4096 2.83144V10.418C34.4096 10.6382 34.2227 10.8148 33.9898 10.8148H32.3824C32.1495 10.8148 31.9625 10.6382 31.9625 10.418V2.83144C31.9625 2.61127 31.7756 2.43458 31.5427 2.43458Z"
      fill="#FF560F"
    />
    <path
      d="M40.6871 0.300781H48.3157C48.5256 0.300781 48.6953 0.461156 48.6953 0.659586V1.99967C48.6953 2.1981 48.5256 2.35847 48.3157 2.35847H43.1169C42.907 2.35847 42.7373 2.51885 42.7373 2.71728V4.13075C42.7373 4.32918 42.907 4.48955 43.1169 4.48955H47.5997C47.8097 4.48955 47.9793 4.64993 47.9793 4.84836V6.18844C47.9793 6.38687 47.8097 6.54724 47.5997 6.54724H43.1169C42.907 6.54724 42.7373 6.70762 42.7373 6.90605V8.39563C42.7373 8.59406 42.907 8.75443 43.1169 8.75443H48.3934C48.6033 8.75443 48.7729 8.91481 48.7729 9.11324V10.4533C48.7729 10.6517 48.6033 10.8121 48.3934 10.8121H40.6843C40.4743 10.8121 40.3047 10.6517 40.3047 10.4533V0.662304C40.3076 0.463874 40.4772 0.300781 40.6871 0.300781Z"
      fill="#FF560F"
    />
    <path
      d="M55.6101 0.232422H57.4446C57.5711 0.232422 57.689 0.305814 57.7379 0.414542L62.2322 10.3986C62.3214 10.597 62.1661 10.8172 61.9389 10.8172H60.0785C59.9491 10.8172 59.8312 10.7438 59.7824 10.6296L58.9283 8.64802C58.8795 8.53386 58.7616 8.46046 58.6322 8.46046H54.3592C54.2298 8.46046 54.1119 8.53386 54.0631 8.64802L53.2091 10.6296C53.1602 10.7438 53.0423 10.8172 52.9129 10.8172H51.1157C50.8886 10.8172 50.7333 10.597 50.8224 10.3986L55.3168 0.414542C55.3656 0.303096 55.4807 0.232422 55.6101 0.232422ZM57.7925 6.0032L56.789 3.68999C56.6797 3.43992 56.3059 3.43992 56.1995 3.68999L55.196 6.0032C55.1097 6.20163 55.265 6.41908 55.4922 6.41908H57.4964C57.7235 6.41908 57.8788 6.20163 57.7925 6.0032Z"
      fill="#FF560F"
    />
  </svg>
);

const FigmaSelectedText = () => (
  <span
    style={{
      color: '#FF560F',
      fontFamily: 'BIZ UDPGothic, sans-serif',
      fontSize: 9,
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '13.5px',
      letterSpacing: '0.675px',
      display: 'inline-block',
    }}
  >
    - コチーム -
  </span>
);

const LogoTitle = () => (
  <span
    style={{
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      marginLeft: 8,
    }}
  >
    <IconFigmaSelected />
    <span style={{ marginTop: 2 }}>
      <FigmaSelectedText />
    </span>
  </span>
);

export default LogoTitle;
